import { COUNTRIES, DEFAULT_PHONE_FORMAT } from '@dealstack/shared/lib/countries/countriesData';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';
import { useMemo } from 'react';
import { PatternFormat } from 'react-number-format';

interface Props {
	className?: string;
	telephonePrefix?: string;
	phoneNumber?: string;
}

export const PhoneNumber = ({ telephonePrefix, phoneNumber, className }: Props) => {
	const phoneFormat = useMemo(() => {
		return COUNTRIES.find(({ dial_code }) => dial_code === telephonePrefix)
			?.phone_number_format;
	}, [telephonePrefix]);

	if (!telephonePrefix || !phoneNumber) {
		return <>{LONG_DASH}</>;
	}

	return (
		<div className={className}>
			{telephonePrefix}&nbsp;
			<PatternFormat
				displayType="text"
				value={phoneNumber}
				format={phoneFormat ?? DEFAULT_PHONE_FORMAT}
			/>
		</div>
	);
};
